"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelsReducer = exports.updateLabelPosition = exports.updateLabelParts = exports.setLabelsRect = exports.updateLabelRect = exports.LabelsActionType = void 0;
const react_1 = require("react");
var LabelsActionType;
(function (LabelsActionType) {
    LabelsActionType["UpdateLabelRect"] = "updateLabelRect";
    LabelsActionType["SetLabelsRect"] = "setLabelsRect";
    LabelsActionType["UpdateLabelParts"] = "updateLabelParts";
    LabelsActionType["UpdateLabelPosition"] = "updateLabelPosition";
})(LabelsActionType || (exports.LabelsActionType = LabelsActionType = {}));
const updateLabelRect = (rect) => ({
    type: LabelsActionType.UpdateLabelRect,
    payload: rect,
});
exports.updateLabelRect = updateLabelRect;
const setLabelsRect = (rects) => ({
    type: LabelsActionType.SetLabelsRect,
    payload: rects,
});
exports.setLabelsRect = setLabelsRect;
const updateLabelParts = (rect) => ({
    type: LabelsActionType.UpdateLabelParts,
    payload: rect,
});
exports.updateLabelParts = updateLabelParts;
const updateLabelPosition = (rect) => ({
    type: LabelsActionType.UpdateLabelPosition,
    payload: rect,
});
exports.updateLabelPosition = updateLabelPosition;
function labelsReducer(state, action) {
    const { type, payload } = action;
    switch (type) {
        case LabelsActionType.SetLabelsRect:
            return Object.assign(Object.assign({}, state), { labelsRect: payload });
        case LabelsActionType.UpdateLabelRect: {
            const labelRect = payload;
            const copyLabels = state.labelsRect.map(rect => {
                if (rect.identifier === labelRect.identifier) {
                    rect.rect = labelRect.rect;
                    return rect;
                }
                return rect;
            });
            return Object.assign(Object.assign({}, state), { labelsRect: copyLabels });
        }
        case LabelsActionType.UpdateLabelPosition: {
            const labelRect = payload;
            const copyLabels = state.labelsRect.map(rect => {
                if (rect.identifier === labelRect.identifier) {
                    rect.rect.x = labelRect.rect.x;
                    rect.rect.y = labelRect.rect.y;
                }
                return rect;
            });
            return Object.assign(Object.assign({}, state), { labelsRect: copyLabels });
        }
        case LabelsActionType.UpdateLabelParts: {
            const labelRect = payload;
            const copyLabels = state.labelsRect.map(rect => {
                if (rect.identifier === labelRect.identifier) {
                    rect.parts = labelRect.parts;
                }
                return rect;
            });
            return Object.assign(Object.assign({}, state), { labelsRect: copyLabels });
        }
        default:
            return state;
    }
}
exports.labelsReducer = labelsReducer;
function useLabelsReducer(state) {
    return (0, react_1.useReducer)(labelsReducer, state);
}
exports.default = useLabelsReducer;
